"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTpaDto = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_address_dto_1 = require("../../address/dto/create-address.dto");
class CreateTpaDto {
}
exports.CreateTpaDto = CreateTpaDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "TPA Name",
        type: String,
        required: true,
        example: "ABC Insurance",
    }),
    (0, class_validator_1.IsString)({ message: "TPA name must be a string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "TPA name should not be empty" }),
    (0, class_validator_1.MaxLength)(200, { message: "TPA name must be at most 200 characters long" }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateTpaDto.prototype, "tpaName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "TPA Display Name",
        type: String,
        required: true,
        example: "ABC Insurance",
    }),
    (0, class_validator_1.IsString)({ message: "Display name must be a string" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Display name should not be empty" }),
    (0, class_validator_1.MaxLength)(100, {
        message: "Display name must be at most 100 characters long",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateTpaDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Company Type ID",
        type: Number,
        required: true,
        example: 19,
    }),
    (0, class_validator_1.IsNumber)({}, { message: "Company Type ID must be a number" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Company Type ID should not be empty" }),
    tslib_1.__metadata("design:type", Number)
], CreateTpaDto.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "website",
        type: String,
        example: "https://www.example.com",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsUrl)({}, { message: "Website must be a valid URL" }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateTpaDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "remarks",
        type: String,
        example: "This is a remark",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Remarks must be a string" }),
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 500) {
            throw new common_1.BadRequestException("Tpa remarks must not exceed 500 characters ");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateTpaDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateTpaDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateTpaDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateTpaDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateTpaDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], CreateTpaDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of addresses associated with the TPA",
        type: [create_address_dto_1.CreateAddressDto],
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_address_dto_1.CreateAddressDto),
    tslib_1.__metadata("design:type", Array)
], CreateTpaDto.prototype, "address", void 0);
